let opps_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
<path d="M30 60C13.4557 60 0 46.5443 0 30C0 13.4557 13.4557 0 30 0C46.5443 0 60 13.4557 60 30C60 46.5443 46.5443 60 30 60ZM30 3.93443C15.6295 3.93443 3.93443 15.6295 3.93443 30C3.93443 44.3705 15.6295 56.0656 30 56.0656C44.3705 56.0656 56.0656 44.3705 56.0656 30C56.0656 15.6295 44.3705 3.93443 30 3.93443Z" fill="black"/>
<path d="M36.394 41.8051C34.2793 41.8051 33.1678 40.9198 32.2727 40.2018C31.5547 39.6313 31.0727 39.2477 29.9907 39.2477C28.9088 39.2477 28.4366 39.6313 27.7186 40.2018C26.8235 40.9198 25.7121 41.8051 23.5973 41.8051C21.4825 41.8051 20.3711 40.9198 19.4858 40.2018C18.7678 39.6313 18.2957 39.2477 17.2137 39.2477H15.7383V36.2969H17.2137C19.3284 36.2969 20.4399 37.1821 21.3252 37.9002C22.0432 38.4805 22.5252 38.8543 23.5973 38.8543C24.6793 38.8543 25.1514 38.4706 25.8694 37.9002C26.7645 37.1821 27.876 36.2969 29.9907 36.2969C32.1055 36.2969 33.217 37.1821 34.1121 37.9002C34.8301 38.4805 35.3121 38.8543 36.394 38.8543C37.476 38.8543 37.9481 38.4706 38.6662 37.9002C39.5612 37.1821 40.6727 36.2969 42.7875 36.2969H44.2629V39.2477H42.7875C41.7055 39.2477 41.2334 39.6313 40.5055 40.2018C39.6202 40.9198 38.5088 41.8051 36.394 41.8051Z" fill="black"/>
<path d="M17.7043 27.0493C19.6056 27.0493 21.147 25.508 21.147 23.6067C21.147 21.7054 19.6056 20.1641 17.7043 20.1641C15.803 20.1641 14.2617 21.7054 14.2617 23.6067C14.2617 25.508 15.803 27.0493 17.7043 27.0493Z" fill="black"/>
<path d="M42.2942 27.0493C44.1955 27.0493 45.7368 25.508 45.7368 23.6067C45.7368 21.7054 44.1955 20.1641 42.2942 20.1641C40.3929 20.1641 38.8516 21.7054 38.8516 23.6067C38.8516 25.508 40.3929 27.0493 42.2942 27.0493Z" fill="black"/>
</svg>`
/** append modal in footer for better UX*/
let body_2 = document.body;
if (!customElements.get('mirr-quick-size-recommended-modal')) {
  class MirrorQuickSizeModalDialog extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
  }

  customElements.define('mirr-quick-size-recommended-modal', MirrorQuickSizeModalDialog);
}



//manage model image on click on gender /


const updateBackgroundImagesQuickSizeAA = (blockId, gender) => {
  const sections = ['chest', 'stomach', 'hip'];
  sections.forEach(section => {
    ['flat', 'mid', 'high'].forEach(type => {
      const element = document.querySelector(`[data-ms-aa-${section}-${type}--${blockId}]`);
      if (element) {
        element.style.backgroundImage = `url(${window.aaImageScrQuickSize[section][gender][type]})`;
      }
    });
  }); 
};

document.querySelectorAll('[data-gender-aa-triggered-cls-quick-size]').forEach(allGenderChoiseEle => {
  allGenderChoiseEle.addEventListener('click', () => {
    const blockId = allGenderChoiseEle.getAttribute('data-block-id');
    const choiseValue = allGenderChoiseEle.getAttribute('value');
    const gender = choiseValue === 'male' ? 'male' : 'female';

    updateBackgroundImagesQuickSizeAA(blockId, gender);
  });
});


setTimeout(function () {


  document.querySelectorAll(".ms-mirr-quick-size-block-modal").forEach(function (quickSizeBlock) {
    let blockId = quickSizeBlock.getAttribute("block-id");

    const autoSelectGender = () => {
      let selectedGender = window.aa_product_gender_mirr_quick_size;

      if (!selectedGender) return;
      if (selectedGender === "unisex") {
        clearInterval(genderInterval);
        return;
      }
      let radio = quickSizeBlock.querySelector(`input[name='gender-${blockId}'][value='${selectedGender}']`);
      if (radio) { radio.checked = true;}
      radio.dispatchEvent(new Event("click", { bubbles: true }));
      quickSizeBlock.querySelectorAll(`input[name='gender-${blockId}']`).forEach(r => r.disabled = true);
      const genderGroup = document.getElementById(`genderGroup-${blockId}`);
      const genderLabel = document.querySelector(`label[for='genderGroup--aa-${blockId}']`);

      if (genderGroup) genderGroup.style.display = "none";
      if (genderLabel) genderLabel.style.display = "none";
      clearInterval(genderInterval);
    };
    const genderInterval = setInterval(autoSelectGender, 200);
    autoSelectGender();


    const steps = [
      `step1-${blockId}`,
      `step2-${blockId}`,
      `step3-${blockId}`,
      `step4-${blockId}`,
      `step5-${blockId}`,
    ];

    let current = 0;

    const nextBtn = quickSizeBlock.querySelector(`#nextBtn-l1--${blockId}`);
    const backBtn = quickSizeBlock.querySelector(`#backBtn-l1--${blockId}`);
    const submitBtn = quickSizeBlock.querySelector(`#submitBtn-l1--${blockId}`);
    let advisorModal = document.querySelector(`.nr-cm-modal--js--${blockId}`);
    let cmmodalfooter = document.querySelector(`.cm-modal-footer-l1--js--${blockId}`);
    let ollst = document.querySelector(`.cm-modal-footer-l1--js--${blockId} ul.ollst`);


    // FIX → use const function expression

    document.querySelector(`#mirr-btn-quick-${blockId}`)?.addEventListener("click", () => {
      body_2.classList.add('nr-cm-modal-open');
      showStep(0);
      advisorModal.style.visibility = 'visible';
      advisorModal.style.opacity = '1';
    });
    document.querySelector(`#cm-close--js--${blockId}`)?.addEventListener("click", () => {
      body_2.classList.remove('nr-cm-modal-open');
      advisorModal.style.visibility = 'hidden';
      advisorModal.style.opacity = '0';
      showStep(0);
      ollst.classList.remove('hidden');
      cmmodalfooter.style.display = 'flex';
      current = 0;
    })

  const  highlightSteps = (stepNumber)=> {
    const allLi = document.querySelectorAll(`.cm-modal-footer-l1--js--${blockId} .ollst li`);
    allLi.forEach((li, i) => {
      li.classList.toggle('active', i === stepNumber);
    });
  }


    const showStep = (index) => {
      document.getElementById(steps[current]).classList.add('hidden');
      current = index;
      document.getElementById(steps[current]).classList.remove('hidden');

       highlightSteps(current);

      nextBtn.classList.toggle('hidden', current === steps.length - 1);
      submitBtn.classList.toggle('hidden', current !== steps.length - 1);



      backBtn.classList.remove('hidden');
      backBtn.disabled = current === 0;
      backBtn.classList.toggle('disabled', current === 0);

      if (window.innerWidth < 991) {
        advisorModal.style.maxWidth = index === 4 ? '98%' : '';
      } else {
        advisorModal.style.maxWidth = index === 4 ? '65%' : '';
      }

      if (current === 3) {
        nextBtn.classList.add('hidden');
        submitBtn.classList.remove('hidden');
      }

      if (current === 4) {
        nextBtn.classList.add('hidden');
        backBtn.classList.add('hidden');
        submitBtn.classList.add('hidden');
        ollst.classList.add('hidden');
        cmmodalfooter.style.display = 'none';
      }
    };

    nextBtn?.addEventListener("click", () => {
      if (current === 0 && !validateFromStep_1L1(blockId)) return;
      if (current < steps.length - 1) showStep(current + 1);
    });

    backBtn?.addEventListener("click", () => {
      if (current > 0) showStep(current - 1);
    });

    submitBtn?.addEventListener("click", () => {
      submitQuickSize(submitBtn, blockId);
    });

    showStep(0);



    const heightInput = document.getElementById(`height-${blockId}`);
    const heightFtIn = document.querySelector(`.cmin-l1-${blockId}`);
    const heightUnit = document.getElementById(`heightUnit-${blockId}`);
    heightUnit.addEventListener('change', () => {
      if (heightUnit.value === 'cm') {
        heightInput.classList.remove('unhidden');
        heightFtIn.classList.add('unhidden');
        heightft.value = '';
        heightin.value = '';
      } else {
        heightInput.classList.add('unhidden');
        heightFtIn.classList.remove('unhidden');
        heightInput.value = '';
      }
    });
    const weightKg = document.getElementById(`weight-${blockId}`);
    const weightLbs = document.getElementById(`weightlbs-${blockId}`);
    const weightUnit = document.getElementById(`weightUnit-${blockId}`);
    if (weightUnit.value === 'kg') {
      weightKg.classList.remove('hidden');
      weightLbs.classList.add('hidden');
    } else {
      weightKg.classList.add('hidden');
      weightLbs.classList.remove('hidden');
    }
    weightUnit.addEventListener('change', () => {
      if (weightUnit.value === 'kg') {
        weightKg.classList.remove('hidden');
        weightLbs.classList.add('hidden');
        weightLbs.value = '';
      } else {
        weightKg.classList.add('hidden');
        weightLbs.classList.remove('hidden');
        weightKg.value = '';
      }
    });
    heightInput.addEventListener('input', () => {
      if (heightInput.value.length > 3) {
        heightInput.value = heightInput.value.slice(0, 3);
      }
    });

    const heightft = document.getElementById(`heightft-${blockId}`);
    heightft.addEventListener('input', () => {
      if (heightft.value.length > 1) {
        heightft.value = heightft.value.slice(0, 1);
      }
    });

    const heightin = document.getElementById(`heightin-${blockId}`);
    heightin.addEventListener('input', () => {
      if (heightin.value.length > 2) {
        heightin.value = heightin.value.slice(0, 2);
      }
    });

    const weight = document.getElementById(`weight-${blockId}`);
    weight.addEventListener('input', () => {
      if (weight.value.length > 3) {
        weight.value = weight.value.slice(0, 3);
      }
    });

    const weightlbs = document.getElementById(`weightlbs-${blockId}`);
    weightlbs.addEventListener('input', () => {
      if (weightlbs.value.length > 3) {
        weightlbs.value = weightlbs.value.slice(0, 3);
      }
    });
    if (window.product_gender_mirr_quick_size) {
      // Select radio button
      let radio = document.querySelector(
        `input[name='gender-${blockId}'][value='${window.product_gender_mirr_quick_size}']`
      );
      if (radio) {
        radio.checked = true;
      }
      // Disable both radios
      document
        .querySelectorAll(`input[name='gender-${blockId}']`)
        .forEach(r => r.disabled = true);
    }



    function submitQuickSize(_this, blockId) {
      var age = Number(document.getElementById(`age-${blockId}`)?.value);
      var gender = document.querySelector(`input[name='gender-${blockId}']:checked`)?.value;
      var height = Number(document.getElementById(`height-${blockId}`)?.value);
      var heightUnit = document.getElementById(`heightUnit-${blockId}`)?.value;
      var weight = Number(document.getElementById(`weight-${blockId}`)?.value);
      var weightUnit = document.getElementById(`weightUnit-${blockId}`)?.value;
      var stomachShape = document.querySelector(`input[name="stomachShape-${blockId}"]:checked`)?.value;
      var chestShape = document.querySelector(`input[name="chestShape-${blockId}"]:checked`)?.value;
      var hipShape = document.querySelector(`input[name="hipShape-${blockId}"]:checked`)?.value;

      var totalHeightMillimeters = Number(height) * 10 //convert cm into mm 1cm = 10 mm, default cm selected
      if (heightUnit == "in") {
        var heightft = Number(document.getElementById(`heightft-${blockId}`)?.value) ?? 0;
        var heightin = Number(document.getElementById(`heightin-${blockId}`)?.value) ?? 0;
        var totalHeightInches = heightft * 12 + heightin;
        // var totalHeightCm = totalHeightInches * 2.54;
        totalHeightMillimeters = totalHeightInches * 25.4; // Convert total height to millimeters
      }
      if (weightUnit == "lbs") {
        var weightlbs = Number(document.getElementById(`weightlbs-${blockId}`)?.value) ?? 0;
        weight = weightlbs / 2.20; // convert lbs to kg
      }
      var formDataObj = {
        merchantId: "annyelegare@gmail.com",
        apiKey: "tRBqbkA6TaGl3SJQF2UiT1eZ9hgXDnxiYX3py83pctdkR4etkyL4jDVfFraSMHA2",
        sku: window.sku,
        height: totalHeightMillimeters.toFixed(2), // Send total height in millimeters to the server
        weight: weight.toFixed(2),
        age: age,
        genderType: 'child',
        gender: gender || "",
        stomachShape: stomachShape,
        chestShape: chestShape,
        hipShape: hipShape,
      };
      var formDataForStore = {
        height: totalHeightMillimeters.toFixed(2), // Send total height in millimeters to the server
        weight: weight.toFixed(2),
        age: age,
        genderType: 'child',
        gender: 'male',
        stomachShape: stomachShape,
        chestShape: chestShape,
        hipShape: hipShape,
      };
      _this.innerHTML = t('gettingSize');
      fetch('https://api.services.mirrorsize.com/api/sdk/quicksize/sku/bmirecommendation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataObj),
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) {
            throw { status: response.status, data };
          }
          return data;
        })
        .then((data) => {
          _this.innerHTML = t('submit');
          // localStorage.setItem(`ms_quick_size_layout_2_form_data--${blockId}`, JSON.stringify(formDataForStore)); 
          if (data.code === 1) {
            if (data.isNewRecom === false) {
              var sizeResult = data.data[0].size;
              // var apparelName = data.data[0].apparelId;
              var apparelName = window.product_title || data.data[0].apparelId;
              // var resHml = `
              //  <div id="sizing-ai">
              //     <div class="row" style="display: flex;justify-content: center;">
              //       <div class="col-md-12">
              //           <h4 class="text-center pb-5 pt-4 fs-1">${t('thankYou')}</h4>
              //       </div>
              //     </div>

              //     <div class="row cust-sizing-ai" style=" display: flex; justify-content: center;">

              //      <div class="cmfinal-rl" style="margin-top:0px">
              //          <p style="font-weight:100">
              //          ${t('recommendation', {
              //               size: `<span style="font-weight:800">${sizeResult}</span>`,
              //               product: `<span style="font-weight:800">${apparelName}</span>`
              //           })}
              //          </p>
              //         <div
              //             class="text-center pb-5 pt-4 fs-1"
              //             style="font-weight: 300; margin-top: 20px;font-size: 20px;"
              //           >
              //             <button type="button" class="addProduct button w-full close-ms-btn-form close-ms-btn-form--${blockId}" id="submitFItForm" tabindex="0">
              //             <span>${t('done')}</span>
              //             </button>
              //         </div>
              //       </div>
              //     </div>
              //  </div>
              // `
               const isSizeNotFound = sizeResult.trim().toLowerCase() === 'size not found';

                const formattedSize = isSizeNotFound
                  ? ''
                  : sizeResult.charAt(0).toUpperCase() + sizeResult.slice(1).toLowerCase();

              var resHml = `
                <div class="size-advisor-result">
                  <div class="size-advisor-result__container">

                    ${
                      !isSizeNotFound
                        ? `
                          <p class="size-advisor-result__subtitle">
                            ${t('recommendation_best_fit')} <strong>"${apparelName}"</strong>
                          </p>
                          <div class="size-advisor-result__size">
                            ${formattedSize}
                          </div>

                          <p class="size-advisor-result__message">
                            ${t('thankYou')}
                          </p>
                        `
                        : `
                          <div class="size-advisor-result__icon">
                            ${opps_icon}
                          </div>

                          <h3 class="size-advisor-result__message">
                            Size not found
                          </h3>
                        `
                    }

                    <button
                      class="addProduct button w-full close-ms-btn-form close-ms-btn-form--${blockId} button--primary"
                      id="submitFItForm">
                      ${t('done')}
                    </button>

                  </div>
                </div>
               
              `;
              document.getElementById(`show_data-${blockId}`).innerHTML = resHml;
              showStep(4);
            } else if (data.isNewRecom === true) {
              var resHtml = `
                    <div id="sizing-ai">
                        <div class="row">
                        <div class="col-md-12">
                            <h4 class="text-center pb-5 pt-4 fs-1">${t('thankYou')}</h4>
                        </div>
                        </div>

                        <div class="row cust-sizing-ai">
                        <!-- TIGHT FIT -->
                        <div class="col-md-4">
                            <p class="text-center">${t('tightFit')}</p>
                            <div class="box1 mx-4 px-4" style="margin-top: 50px;">
                            <label><span id="size_name1">${data.data[0]?.fitScore?.sizeBefore}</span></label>
                            <div class="position-relative">
                                <span class="process_bar"></span>
                                <span class="process_btn" id="size_score10" style="left: calc(${(data.data[0]?.fitScore?.sizeBefore_score > 10 ? data.data[0]?.fitScore?.sizeBefore_score : 10)}% - 10%);"></span>
                            </div>
                            <div>
                                <div class="d-flex justify-content-between">
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                </div>
                            </div>
                            </div>
                            <div class="d-flex d_sizing_name justify-content-between">
                            <span>Slightly Tight</span>
                            <span>Tight</span>
                            <span>Very Tight</span>
                            </div>
                        </div>

                        <!-- BEST FIT -->
                        <div class="col-md-4">
                            <p class="text-center">${t('bestFit')}</p>
                            <div class="g_circle" style="width:150px; margin:0 auto; position: relative;">
                            <svg width="100%" height="100%" viewBox="0 0 42 42" class="donut">
                              <circle class="donut-hole" cx="21" cy="21" r="15.91549430918954" fill="#fff"></circle>
                              <circle class="donut-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#ebeef0" stroke-width="3"></circle>
                              <circle class="donut-segment" id="gourav_svg" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#4f4e4e" stroke-width="3" stroke-dashoffset="25" stroke-dasharray="${data.data[0]?.fitScore?.recomSize_score} ${100 - data.data[0]?.fitScore?.recomSize_score}"></circle>
                            </svg>
                            <h4 style="color:#000; position: absolute; top: 58px; width: 100%; text-align: center; font-size: 18px; font-weight: 800; margin-bottom: 0px;">
                                <span id="size_name3">${data.data[0]?.fitScore?.recomSize}</span>
                            </h4>
                            <span class="size_name3_sss-p"> Fit Score: <small id="size_name3_sss">${Math.ceil(data.data[0]?.fitScore?.recomSize_score)}% </small> </span>
                            </div>
                        </div>

                        <!-- LOOSE FIT -->
                        <div class="col-md-4">
                            <p class="text-center">${t('looseFit')}</p>
                            <div class="box1 mx-4 px-4" style="margin-top: 50px;">
                            <label><span id="size_name2">${data.data[0]?.fitScore?.sizeAfter}</span></label>
                            <div class="position-relative">
                                <span class="process_bar green"></span>
                                <span class="process_btn1 green" id="size_score30" style="left: calc(${(data.data[0]?.fitScore?.sizeAfter_score > 10 ? data.data[0]?.fitScore?.sizeAfter_score : 10)}% - 10%);"></span>
                            </div>
                            <div>
                                <div class="d-flex justify-content-between">
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                <span class="b_line"></span>
                                </div>
                            </div>
                            </div>
                            <div class="d-flex d_sizing_name justify-content-between">
                            <span>Slightly Loose</span>
                            <span>Loose</span>
                            <span>Very Loose</span>
                            </div>
                        </div>
                        </div>

                        <div class="cmfinal-rl">
                       <p> Your recommended "Length" size is : <span id="apparelName" style="font-weight: 700">${data.data[0]?.fitScore?.recomSize}</span></p>
                        <div
                            class="text-center pb-5 pt-4 fs-1"
                            style="font-weight: 300; margin-top: 20px;font-size: 20px;"
                          >
                            <button type="button" class="addProduct button w-full close-ms-btn-form close-ms-btn-form--${blockId}" id="submitFItForm" tabindex="0">
                            <span>${t('done')}</span>
                            </button>
                          </div>
                        </div>
                    </div>
                     
                    `;

              document.getElementById(`show_data-${blockId}`).innerHTML = resHtml;
              showStep(4);

            }
          } else {
            console.log("Error in ms get size.",);
            document.getElementById(`response-error-${blockId}`).innerHTML = data.message
            setTimeout(function () {
              document.getElementById(`response-error-${blockId}`).innerHTML = "";
            }, 5000);
          }
        })
        .catch((error) => {
          _this.innerHTML = t('submit');
          console.error('Error :', error);
          if (error?.data?.message) {
            document.getElementById(`response-error-${blockId}`).innerHTML = error?.data?.message ?? '';
            setTimeout(function () {
              document.getElementById(`response-error-${blockId}`).innerHTML = "";
            }, 5000);
          }

        })
    };

    const weightUnitElet = document.getElementById(`weightUnit-${blockId}`);
    weightUnitElet.value = "kg";
    weightUnitElet.dispatchEvent(new Event('change', { bubbles: true }));

    const heightUnitElet = document.getElementById(`heightUnit-${blockId}`);
    heightUnitElet.value = "cm";
    heightUnitElet.dispatchEvent(new Event('change', { bubbles: true }));


    document.addEventListener('click', function (e) {
      const btn = e.target.closest(`.close-ms-btn-form--${blockId}`);
      if (btn) {
        e.preventDefault();
        const target = document.querySelector(`#cm-close--js--${blockId}`);
        if (target) target.click();
      }
    }, true);
  });


}, 2000);


function validateFromStep_1L1(blockId) {

  let isValid = true;

  // Clear all previous errors
  document.querySelectorAll(`.form-error-${blockId}`).forEach(err => err.innerHTML = "");

  // Age validation
  const age = document.getElementById(`age-${blockId}`).value;
  if (!age) {
    document.querySelector(`.age_error-${blockId}`).innerHTML = t('validation.selectAge');
    isValid = false;
  }

  // Height validation
  const heightUnit = document.getElementById(`heightUnit-${blockId}`).value;

  if (heightUnit === "cm") {
    const heightCm = parseInt(document.getElementById(`height-${blockId}`).value, 10);
    if (!heightCm || isNaN(heightCm)) {
      document.querySelector(`.height_unit_error-${blockId}`).innerHTML = t('validation.enterHeight');
      isValid = false;
    } else if (heightCm < 60 || heightCm > 220) {
      document.querySelector(`.height_unit_error-${blockId}`).innerHTML = t('validation.heightCmRange');
      isValid = false;
    }
  } else {
    const heightFt = parseInt(document.getElementById(`heightft-${blockId}`).value, 10) || 0;
    const heightIn = parseInt(document.getElementById(`heightin-${blockId}`).value, 10) || 0;
    const inches = (heightFt * 12) + heightIn;
    const heightmm = ((inches * 2.54) * 10).toFixed(2);
    if (heightFt === 0 && heightIn === 0) {
      document.querySelector(`.height_unit_error-${blockId}`).innerHTML = t('validation.enterHeight');
      isValid = false;
    } else if (heightmm < 600 || heightmm > 2200) {
      document.querySelector(`.height_unit_error-${blockId}`).innerHTML = t('validation.heightFtRange');
      isValid = false;
    }
  }

  // Weight validation
  const weightUnit = document.getElementById(`weightUnit-${blockId}`).value;

  if (weightUnit === "kg") {
    const weightKg = parseInt(document.getElementById(`weight-${blockId}`).value, 10);
    if (!weightKg || isNaN(weightKg)) {
      document.querySelector(`.weight_unit_error-${blockId}`).innerHTML = t('validation.enterWeightKg');
      isValid = false;
    } else if (weightKg < 12 || weightKg > 150) {
      document.querySelector(`.weight_unit_error-${blockId}`).innerHTML = t('validation.weightKgRange');
      isValid = false;
    }
  } else {
    const weightLbs = parseInt(document.getElementById(`weightlbs-${blockId}`).value, 10);
    if (!weightLbs || isNaN(weightLbs)) {
      document.querySelector(`.weight_unit_error-${blockId}`).innerHTML = t('validation.enterWeightLbs');
      isValid = false;
    } else if (weightLbs < 27 || weightLbs > 333) {
      document.querySelector(`.weight_unit_error-${blockId}`).innerHTML =t('validation.weightLbsRange');
      isValid = false;
    }
  }

  // Gender validation (if required)
  const genderChecked = document.querySelector(`input[name^='gender-${blockId}']:checked`);
  if (!genderChecked) {
    document.querySelector(`.gender_error-${blockId}`).innerHTML = t('validation.selectGender');
    isValid = false;
  }

  // If any error — stop
  if (!isValid) return false;

  // Success
  //showStep(2);
  return true;
}



